import { render, staticRenderFns } from "./target.vue?vue&type=template&id=f0a58866&"
import script from "./target.vue?vue&type=script&lang=ts&"
export * from "./target.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports